import axios from 'axios';
import {camelizeKeys, decamelizeKeys} from 'humps';

axios.defaults.baseURL =
  process.env.NODE_ENV === 'production'
    ? // tslint:disable-next-line:no-any
      (window as any).API_ROOT
    : process.env.REACT_APP_API_ROOT;

axios.interceptors.response.use(
  response => {
    response.data = camelizeKeys(response.data);
    return response;
  },
  error => Promise.resolve(error.response)
);

export default {
  get(url: string, params?: {}) {
    return axios({
      method: 'get',
      url,
      params: params ? decamelizeKeys(params) : {}
    });
  },

  post(url: string, data: {} = {}) {
    return axios({
      method: 'post',
      url,
      data: decamelizeKeys(data)
    });
  },

  put(url: string, data: {} = {}) {
    return axios({
      method: 'put',
      url,
      data: decamelizeKeys(data)
    });
  },

  delete(url: string) {
    return axios({
      method: 'delete',
      url
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/httpClient.ts